import type { ComponentProps, ReactNode } from 'react';
import React from 'react';
import { Flex } from '@skin-seoul/design-system';
type SectionContainerProps = {
  children: ReactNode;
  containerWrapperProps?: ComponentProps<typeof Flex>;
  containerInnerProps?: ComponentProps<typeof Flex>;
};
const SectionContainer = ({
  children,
  containerInnerProps,
  containerWrapperProps
}: SectionContainerProps) => {
  return <Flex alignItems="center" justifyContent="center" maxWidth="100vw" width="100%" {...containerWrapperProps} data-sentry-element="Flex" data-sentry-component="SectionContainer" data-sentry-source-file="index.tsx">
      {/* 1280px + (16px + 16px) Mobile padding */}
      <Flex flexDirection="column" marginX="auto" maxWidth="1280px" paddingX={{
      base: 4,
      tablet: 6,
      desktop: 10
    }} paddingY={{
      base: 8,
      tablet: 18,
      desktop: 18
    }} width="100%" {...containerInnerProps} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        {children}
      </Flex>
    </Flex>;
};
export default SectionContainer;